import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/[...not_found]/404.tsx");
